export class BlueyonderLogisticGroup {
  name: string;
  code: string;

  static fromDto(c): BlueyonderLogisticGroup {
    if (!c) {
      return null;
    }

    const byLogisticGroup = new BlueyonderLogisticGroup();

    byLogisticGroup.name = c.name;
    byLogisticGroup.code = c.code;

    return byLogisticGroup;
  }
}
